module.exports = __webpack_public_path__ + "static/img/ipad@2x.7320b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aerospace/ipad@2x.png
// module id = 6KzO
// module chunks = 1